
import Vue from "vue";
import Component from "vue-class-component";
import SectionPageHeading from "@/features/shared/components/sections/SectionPageHeading.vue";
import {DuplicableDocumentModelDocumentType, EndorsementLightViewModel, EndorsementsClient, EndorsementStatus, SeafarerActions, SysAdminOrganizationsClient} from "@/api-client";
import {Prop} from "vue-property-decorator";
import {factory} from '@/api-client.extensions';
import userInfo from "@/features/shared/components/UserInfo";
import FilterCheckbox from "@/components/FilterCheckbox.vue";
import {BModal} from "bootstrap-vue";
import NewEndorsementCard from "@/features/applications/components/new-application/NewEndorsementCard.vue";
import NewDuplicateCard from "@/features/applications/components/new-application/NewDuplicateCard.vue";
import {NavigationGuardNext} from "vue-router/types/router";
import EndorsementsTable from "@/features/personProfile/components/EndorsementsTable.vue";

class Filters{
    showValid = true;
    showInvalid = false;
    showSuspended = true;
}

interface Props {
    seafarerId: string;
    endorsements: EndorsementLightViewModel[];
    seafarerActions: SeafarerActions;
}

@Component( {
    components: {
        EndorsementsTable,
        SectionPageHeading,
        FilterCheckbox,
        NewEndorsementCard,
        NewDuplicateCard
    },
    beforeRouteEnter (to, from, next: NavigationGuardNext<EndorsementList>) {
        const props = to.meta!.props as Props;
        Promise.all([
            new EndorsementsClient().endorsements(to.params.seafarerId)
        ]).then(values => {
            props.seafarerId = to.params.seafarerId;
            props.endorsements = values[0];
            next();
        }).catch(e => next(e))
    }
})
export default class EndorsementList extends Vue implements Props {
    @Prop({ required: true })
    seafarerId!: string;
    @Prop({ required: true})
    endorsements!: EndorsementLightViewModel[];
    @Prop({required: false, default: () => factory.create(SeafarerActions) })
    seafarerActions!: SeafarerActions;

    userInfo = userInfo;
    filters = new Filters();

    $refs!: {
        newApplicationModal: BModal;
    }

    duplicateDocumentType = DuplicableDocumentModelDocumentType;

    openNewApplicationModal() {
        this.$refs.newApplicationModal.show();
    }

    private get filteredEndorsements(): EndorsementLightViewModel[] {
        return this.endorsements.filter(item =>
            this.filters.showValid && item.status == EndorsementStatus.Valid
            || this.filters.showInvalid && item.status == EndorsementStatus.Invalid
            || this.filters.showSuspended && item.status == EndorsementStatus.Suspended);
    }

}
